import { Button } from "@components/Buttons"
import { Checkbox } from "@components/FormFields"
import { useIntl } from "@components/Intl"
import { Box } from "@components/Layout"
import {
  Sidebar as BaseSidebar,
  SidebarHeader,
} from "@components/SlidingSidebar"
import { ParagraphTitle, TitleM } from "@components/Typography"
import { AnimatePresence, motion } from "framer-motion"
import React from "react"

interface Props {
  uid: string
  title: string
  active: boolean
  cut: string | null
  onCloseSidebar: () => void
  onToggleCut: (cut: string) => void
  onReset: () => void
  dynamicFilters: {
    [key: string]: string[]
  }
}

const Sidebar: React.FC<Props> = ({
  uid,
  title,
  active,
  cut,
  onToggleCut,
  onReset,
  onCloseSidebar,
  dynamicFilters,
}) => {
  const { messages } = useIntl()
  return (
    <BaseSidebar
      isOpen={active}
      header={
        <SidebarHeader showBorder={true} onClose={onCloseSidebar}>
          <TitleM as="h2">Filter {title.toLowerCase()}</TitleM>
        </SidebarHeader>
      }
      handleClose={onCloseSidebar}
    >
      <Box>
        {dynamicFilters["cut"] && uid === "gemstones" ? (
          <>
            <ParagraphTitle>{messages.properties.cut.title}</ParagraphTitle>
            {dynamicFilters["cut"].map((key) => (
              <Checkbox
                checked={cut === key}
                key={key}
                onClick={() => onToggleCut(key)}
              >
                {messages.properties.cut.options[key]}
              </Checkbox>
            ))}
          </>
        ) : null}
      </Box>
      <Box my={5}>
        <AnimatePresence>
          {cut && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              key="toggle"
            >
              <Button variant="purple-border" onClick={onReset}>
                Reset filter
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </Box>
    </BaseSidebar>
  )
}

export default Sidebar
